// Date 2020-10-10 14:00:26

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";

import sithMesMstLocationEdit from "@/views/sithMes/mst/SithMesMstLocationEdit.vue";
import sithMesMstLocationList from "@/views/sithMes/mst/SithMesMstLocationList.vue";
import sithMesMstShiftTeamList from "@/views/sithMes/mst/SithMesMstShiftTeamList.vue";
import sithMesMstShiftTeamEdit from "@/views/sithMes/mst/SithMesMstShiftTeamEdit.vue";
import sithMesMstPositionList from "@/views/sithMes/mst/SithMesMstPositionList.vue";
import sithMesMstPositionEdit from "@/views/sithMes/mst/SithMesMstPositionEdit.vue";
import sithMesMstUserLocationEdit from "@/views/sithMes/mst/SithMesMstUserLocationEdit.vue";
import sithMesMstUserLocationList from "@/views/sithMes/mst/SithMesMstUserLocationList.vue";
import sithMesMstUserPositionEdit from "@/views/sithMes/mst/SithMesMstUserPositionEdit.vue";
import sithMesMstUserPositionList from "@/views/sithMes/mst/SithMesMstUserPositionList.vue";
import sithMesMstWorkshopList from "@/views/sithMes/mst/SithMesMstWorkshopList.vue";
import sithMesMstWorkshopEdit from "@/views/sithMes/mst/SithMesMstWorkshopEdit.vue";
import sithMesMstWorkshopLocationList from "@/views/sithMes/mst/SithMesMstWorkshopLocationList.vue";
import sithMesMstWorkshopLocationEdit from "@/views/sithMes/mst/SithMesMstWorkshopLocationEdit.vue";
import sithMesMstBomEdit from "@/views/sithMes/mst/SithMesMstBomEdit.vue";
import sithMesMstBomList from "@/views/sithMes/mst/SithMesMstBomList.vue";
import sithMesReportTemplateRoleList from "@/views/sithMes/mst/SithMesReportTemplateRoleList.vue";
import sithMesReportTemplateRoleEdit from "@/views/sithMes/mst/SithMesReportTemplateRoleEdit.vue";
import sithMesReportTemplateEdit from "@/views/sithMes/mst/SithMesReportTemplateEdit.vue";
import sithMesReportTemplateList from "@/views/sithMes/mst/SithMesReportTemplateList.vue";
import sithMesMstProjectPlanTemplateList from "@/views/sithMes/mst/SithMesMstProjectPlanTemplateList.vue";
import sithMesMstProjectPlanTemplateEdit from "@/views/sithMes/mst/SithMesMstProjectPlanTemplateEdit.vue";
import sithMesMstMilestoneList from "@/views/sithMes/mst/SithMesMstMilestoneList.vue";
import sithMesMstMilestoneEdit from "@/views/sithMes/mst/SithMesMstMilestoneEdit.vue";
import sithMesMstKamEdit from "@/views/sithMes/mst/SithMesMstKamEdit.vue";
import sithMesMstKamList from "@/views/sithMes/mst/SithMesMstKamList.vue";
import sithMesMstLocalStorageEdit from "@/views/sithMes/mst/SithMesMstLocalStorageEdit.vue";
import sithMesMstLocalStorageList from "@/views/sithMes/mst/SithMesMstLocalStorageList.vue";
import sithMesMstMaterialBasicList from "@/views/sithMes/mst/SithMesMstMaterialBasicList.vue";
import sithMesMstMaterialEdit from "@/views/sithMes/mst/SithMesMstMaterialEdit.vue";
import sithMesMstBasicOperationList from "@/views/sithMes/mst/SithMesMstBasicOperationList.vue";
import sithMesMstBasicOperationEdit from "@/views/sithMes/mst/SithMesMstBasicOperationEdit.vue";
import sithMesMstBasicHeaderList from "@/views/sithMes/mst/SithMesMstBasicHeaderList.vue";
import sithMesMstBasicHeaderEdit from "@/views/sithMes/mst/SithMesMstBasicHeaderEdit.vue";
import sithMesMstKamListEdit from "@/views/sithMes/mst/SithMesMstKamListEdit.vue";
import sithMesMstKamListList from "@/views/sithMes/mst/SithMesMstKamListList.vue";
import sithMesMstMaterialDocumentEdit from "@/views/sithMes/mst/SithMesMstMaterialDocumentEdit.vue";
import sithMesMstMaterialDocumentList from "@/views/sithMes/mst/SithMesMstMaterialDocumentList.vue";
import sithMesMstMaterialTask from "@/views/sithMes/mst/SithMesMstMaterialTask";
import sithMesMstMaterialList from "@/views/sithMes/mst/SithMesMstMaterialList";
import sithMesMstMaterialTaskBatch from "@/views/sithMes/mst/SithMesMstMaterialTaskBatch.vue";
import sithMesMstMaterialDrawingList from "@/views/sithMes/mst/SithMesMstMaterialDrawingList.vue";
import sithMesMstMaterialDrawingEdit from "@/views/sithMes/mst/SithMesMstMaterialDrawingEdit.vue";
import sithMesMstMaterialDrawingManagementEdit from "@/views/sithMes/mst/SithMesMstMaterialDrawingManagementEdit.vue";
import sithMesMstMaterialDrawingManagementList from "@/views/sithMes/mst/SithMesMstMaterialDrawingManagementList.vue";
import MaterialBaseExtendTaskPage from "@/views/sithMes/mst/materialMaintain/MaterialBaseExtendTaskPage.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
    //公用组件注册
    {
        path: "/sithMes/mst/sithMesMstLocationShiftRule/list",
        name: "sithMesMstLocationShiftRuleList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstLocationShiftRule/edit",
        name: "sithMesMstLocationShiftRuleEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstShift/list",
        name: "sithMesMstShiftList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstShift/edit",
        name: "sithMesMstShiftEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstShiftRule/list",
        name: "sithMesMstShiftRuleList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstShiftRule/edit",
        name: "sithMesMstShiftRuleEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstShiftTime/list",
        name: "sithMesMstShiftTimeList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstShiftTime/edit",
        name: "sithMesMstShiftTimeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstCalendar/list",
        name: "sithMesMstCalendarList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstCalendar/edit",
        name: "sithMesMstCalendarEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstShiftTeamUser/list",
        name: "sithMesMstShiftTeamUserList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstShiftTeamUser/edit",
        name: "sithMesMstShiftTeamUserEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstBottleneck/list",
        name: "sithMesMstBottleneckList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstBottleneck/edit",
        name: "sithMesMstBottleneckEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    //自定义页面注册
    {
        path: "/sithMes/mst/sithMesMstLocationEdit",
        name: "sithMesMstLocationEdit",
        component: sithMesMstLocationEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstLocationList",
        name: "sithMesMstLocationList",
        component: sithMesMstLocationList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstShiftTeamList",
        name: "sithMesMstShiftTeamList",
        component: sithMesMstShiftTeamList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstShiftTeamEdit",
        name: "sithMesMstShiftTeamEdit",
        component: sithMesMstShiftTeamEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstPositionList",
        name: "sithMesMstPositionList",
        component: sithMesMstPositionList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstPositionEdit",
        name: "sithMesMstPositionEdit",
        component: sithMesMstPositionEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstUserLocationEdit",
        name: "sithMesMstUserLocationEdit",
        component: sithMesMstUserLocationEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstUserLocationList",
        name: "sithMesMstUserLocationList",
        component: sithMesMstUserLocationList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstUserPositionEdit",
        name: "sithMesMstUserPositionEdit",
        component: sithMesMstUserPositionEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstUserPositionList",
        name: "sithMesMstUserPositionList",
        component: sithMesMstUserPositionList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstWorkshopList",
        name: "sithMesMstWorkshopList",
        component: sithMesMstWorkshopList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstWorkshopEdit",
        name: "sithMesMstWorkshopEdit",
        component: sithMesMstWorkshopEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstWorkshopLocationList",
        name: "sithMesMstWorkshopLocationList",
        component: sithMesMstWorkshopLocationList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstWorkshopLocationEdit",
        name: "sithMesMstWorkshopLocationEdit",
        component: sithMesMstWorkshopLocationEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstBomEdit",
        name: "sithMesMstBomEdit",
        component: sithMesMstBomEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstBomList",
        name: "sithMesMstBomList",
        component: sithMesMstBomList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesReportTemplateRoleList",
        name: "sithMesReportTemplateRoleList",
        component: sithMesReportTemplateRoleList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesReportTemplateRoleEdit",
        name: "sithMesReportTemplateRoleEdit",
        component: sithMesReportTemplateRoleEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesReportTemplateEdit",
        name: "sithMesReportTemplateEdit",
        component: sithMesReportTemplateEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesReportTemplateList",
        name: "sithMesReportTemplateList",
        component: sithMesReportTemplateList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMachineType/list",
        name: "sithMesMstMachineTypeList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMachineType/edit",
        name: "sithMesMstMachineTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstProjectPlanTemplateList",
        name: "sithMesMstProjectPlanTemplateList",
        component: sithMesMstProjectPlanTemplateList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstProjectPlanTemplateEdit",
        name: "sithMesMstProjectPlanTemplateEdit",
        component: sithMesMstProjectPlanTemplateEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMilestoneList",
        name: "sithMesMstMilestoneList",
        component: sithMesMstMilestoneList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMilestoneEdit",
        name: "sithMesMstMilestoneEdit",
        component: sithMesMstMilestoneEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstKamEdit",
        name: "sithMesMstKamEdit",
        component: sithMesMstKamEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstKamList",
        name: "sithMesMstKamList",
        component: sithMesMstKamList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstLocalStorageEdit",
        name: "sithMesMstLocalStorageEdit",
        component: sithMesMstLocalStorageEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstLocalStorageList",
        name: "sithMesMstLocalStorageList",
        component: sithMesMstLocalStorageList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMaterialBasicList",
        name: "sithMesMstMaterialBasicList",
        component: sithMesMstMaterialBasicList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMaterialTask",
        name: "sithMesMstMaterialTask",
        component: sithMesMstMaterialTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMaterialTaskBatch",
        name: "sithMesMstMaterialTaskBatch",
        component: sithMesMstMaterialTaskBatch,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMaterialList",
        name: "sithMesMstMaterialList",
        component: sithMesMstMaterialList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMaterialEdit",
        name: "sithMesMstMaterialEdit",
        component: sithMesMstMaterialEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstBasicOperationList",
        name: "sithMesMstBasicOperationList",
        component: sithMesMstBasicOperationList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstBasicOperationEdit",
        name: "sithMesMstBasicOperationEdit",
        component: sithMesMstBasicOperationEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstBasicHeaderList",
        name: "sithMesMstBasicHeaderList",
        component: sithMesMstBasicHeaderList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstBasicHeaderEdit",
        name: "sithMesMstBasicHeaderEdit",
        component: sithMesMstBasicHeaderEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstKamListEdit",
        name: "sithMesMstKamListEdit",
        component: sithMesMstKamListEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstKamListList",
        name: "sithMesMstKamListList",
        component: sithMesMstKamListList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstLocationTagLoct/list",
        name: "sithMesMstLocationTagLoctList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstLocationTagLoct/edit",
        name: "sithMesMstLocationTagLoctEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMaterialDocumentEdit",
        name: "sithMesMstMaterialDocumentEdit",
        component: sithMesMstMaterialDocumentEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMaterialDocumentList",
        name: "sithMesMstMaterialDocumentList",
        component: sithMesMstMaterialDocumentList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMaterialDrawingList",
        name: "sithMesMstMaterialDrawingList",
        component: sithMesMstMaterialDrawingList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMaterialDrawingEdit",
        name: "sithMesMstMaterialDrawingEdit",
        component: sithMesMstMaterialDrawingEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMaterialDrawingManagementEdit",
        name: "sithMesMstMaterialDrawingManagementEdit",
        component: sithMesMstMaterialDrawingManagementEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sithMesMstMaterialDrawingManagementList",
        name: "sithMesMstMaterialDrawingManagementList",
        component: sithMesMstMaterialDrawingManagementList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    //定制化页面
    {
        path: "/sithMes/mst/materialExtendPage",
        name: "materialBaseExtendTaskPage",
        component: MaterialBaseExtendTaskPage
    }
]
